<template>
  <div class="page flex-col">
    <AppHeader />

    <div class="sol-banner">
      <div class="sol-banner-mask">
        <span class="sol-banner-zh">解决方案</span>
        <span class="sol-banner-en">Solution</span>
      </div>
    </div>

    <div class="sol-main">
      <nav class="sol-breadcrumb">
        <router-link :to="homeLink">首页</router-link>
        <span class="sol-crumb-sep">&gt;</span>
        <router-link :to="listLink">解决方案</router-link>
        <span class="sol-crumb-sep">&gt;</span>
        <span class="sol-crumb-active">重点场所反无人机综合防护解决方案</span>
      </nav>

      <div class="sol-slides">
        <img
          v-for="(img, index) in slideImages"
          :key="'slide_' + index"
          class="sol-slide-img"
          :src="img"
          :alt="'解决方案内容 ' + (index + 1)"
        />
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import { siteHomeLink } from '@/utils/lang';

export default {
  name: 'SolutionZh',
  data() {
    return {
      slideImages: [
        require('./assets/img/FigmaDDSSlicePNG19a3dafacab41b61317e81f3236e4e25.png'),
        require('./assets/img/FigmaDDSSlicePNGf962ecd4aa65992b5f5c7d4078ad5b7b.png'),
        require('./assets/img/FigmaDDSSlicePNG1ded23dadd94aadcfcd0184a85af76d5.png'),
        require('./assets/img/FigmaDDSSlicePNG519e847e83a3c41117b089967866c398.png'),
        require('./assets/img/FigmaDDSSlicePNG5f49375157012d5a250313e8d7fe3955.png')
      ]
    };
  },
  computed: {
    homeLink() {
      return siteHomeLink(this.$route);
    },
    listLink() {
      return { path: '/products', query: { cat: 'solution' } };
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background: #0f1a2c;
}

.sol-banner {
  width: 100%;
  height: 360px;
  margin-top: 8px;
  background: url(./assets/img/FigmaDDSSlicePNG489dbfdb943dd038de62181373940141.jpg)
    center center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.sol-banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.28);
}

.sol-banner-mask {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.sol-banner-zh {
  color: #fff;
  font-size: 40px;
  font-weight: 900;
  line-height: 1.2;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.sol-banner-en {
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  line-height: 1.2;
}

.sol-main {
  width: 1550px;
  max-width: 92%;
  margin: 0 auto;
  padding: 28px 0 80px;
  box-sizing: border-box;
}

.sol-breadcrumb {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 28px;
}

.sol-breadcrumb a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.sol-breadcrumb a:hover {
  color: #83a0ff;
}

.sol-crumb-sep {
  color: rgba(255, 255, 255, 0.45);
}

.sol-crumb-active {
  color: #83a0ff;
}

.sol-slides {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sol-slide-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
}

@media (max-width: 900px) {
  .sol-banner {
    height: 220px;
  }

  .sol-banner-zh {
    font-size: 28px;
  }
}
</style>
